export enum EmailType {
  INBOUND = 1,
  OUTBOUND = 2
}
